import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IBanner } from 'src/app/interfaces/strapi';
import { NgIf } from '@angular/common';

enum StudentLifeBannerEnum {
  studnetLifeRoute = 'app/student-life',
}

@Component({
    selector: 'app-student-life-banner',
    templateUrl: 'student-life-banner.component.html',
    styleUrls: ['./student-life-banner.component.scss'],
    imports: [NgIf],
})
export class StudentLifeBannerComponent {
  public StudentLifeEnum = StudentLifeBannerEnum;

  @Input()
  public showBanner: boolean = false;

  @Input()
  public banner: IBanner | null = <IBanner | null>{};

  @Input()
  public useSecondaryButton = false;

  constructor(private router: Router) {}

  public navigate(): void {
    this.router
      .navigateByUrl(
        `${StudentLifeBannerEnum.studnetLifeRoute}?tag=${
          this.banner?.filter_id ?? -1
        }`
      )
      .finally(() => false);
  }
}
